



































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import cCard from "@/components/default/Card.vue";
import {
  DxCircularGauge,
  DxScale,
  DxGeometry,
  DxSubvalueIndicator,
  DxTitle,
  DxFont,
} from "devextreme-vue/circular-gauge";

import notificationService from "@/services/notificationService";
import {
  MeasuringStateRatingAverageInfoDto,
  MeasuringStatesRatingClient,
} from "@/data/web-api-client";

@Component({
  components: {
    cCard,
    DxCircularGauge,
    DxScale,
    DxGeometry,
    DxSubvalueIndicator,
    DxTitle,
    DxFont,
  },
})
export default class SubcontractorAverageRatingCard extends Vue {
  @Prop({ required: true })
  public subcontractorId!: string;
  private averageRating: MeasuringStateRatingAverageInfoDto =
    new MeasuringStateRatingAverageInfoDto();

  private measuringStateRatingsClient = new MeasuringStatesRatingClient(
    undefined,
    this.$axios
  );

  private async mounted() {
    await this.measuringStateRatingsClient
      .getAverageBySubcontractor(this.subcontractorId)
      .then((result) => {
        this.averageRating = result;
      });
  }
}
